module.exports = __webpack_public_path__ + "img/piece.a260b77c.png";